<template>
    <div style="width: 415px">
        <div id="xButt" class="delete  top10" @click="$parent.closeRightBar"></div>
        <div style="position: fixed; width:415px; z-index: 2" class="">
            <div class="has-text-white is-size-4 has-background-dark pad10">ACTIVITY</div>
            <div class="has-text-white is-size-4 has-background-dark has-text-left pad10">
                <b>&nbsp;{{obj.listName}}</b>
            </div>
           
           <div class="top-15 has-background-dark">
                <div v-if="!inPublic" class="has-background-dark pad10 top-20 is-inline-block">
                        <div class="top-5 has-text-left">
                            <div class="histFilterControl" :class="{makeLight: !fmiimus}" @click="toggleFilter('m')">miimus</div>
                            <div class="histFilterControl" :class="{makeLight: !fbundles}" @click="toggleFilter('b')">bundles</div>
                            <div class="histFilterControl" :class="{makeLight: !fcomments}" @click="toggleFilter('c')">comments</div>
                            <div class="histFilterControl" :class="{makeLight: !fratings}" @click="toggleFilter('r')">ratings</div>
                        </div>
                </div>
                <div v-if="inPublic" class="has-text-white left15 has-background-dark is-inline-block">Public Comments</div>
   
                <div v-if="obj.caller.data.isPublic" class="is-inline-block  right10 is-inline-block is-pulled-right has-background-dark has-text-white">
                    <span class="is-size-7 handCursor " :class="{commentsToggle: !inPublic}" @click="flipPublic">collab</span> | <span class="is-size-7 handCursor" :class="{commentsToggle: inPublic}" @click="flipPublic">public</span>
                </div> 


           </div>
        </div>
      
       <br><br><br><br><br><br>
       <div v-show="hists.length == 0 && origHists.length == 0" class="is-loading"><br><br><br></div>
        <div id="loader">&nbsp;</div>
        
      
      <div v-if="!inPublic" class="top-20">
          
           <table border="1" width="100%">
                <tr class=" has-text-white is-size-6" v-for="(item, i) in filtered" :key="i">
                    <td style="padding: 0 5px 0 5px"> 
                    <div v-if="obj.lastActivityId < item.id" class="has-text-notifGreen is-size-4 is-inline-block lastActivityIndicator"><b>&bull;</b></div>
                    <timeago class="is-size-8" :datetime="item.dateCreated" :autoUpdate="0"></timeago><!-- <span class="is-size-8">{{az.dateConvert(item.dateCreated)}}</span> --></td>
                    <td style="padding-left: 5px; padding-bottom: 8px; ; padding-top: 4px"><span class="notMineHistory">{{initials(item.id_cog)}}</span>&nbsp;<span class="is-size-65" v-html="build(item)"></span></td>
                   
                </tr>
            </table>
      </div>

      <div v-if="inPublic" class="top-20">
          
          <table border="1" width="100%">
               <tr class=" has-text-white is-size-6" v-for="(item2, i2) in pComments" :key="i2">
                   <td style="padding: 0 5px 0 5px"> 
                   <div v-if="obj.lastActivityId < item2.id" class="has-text-notifGreen is-size-4 is-inline-block lastActivityIndicator"><b>&bull;</b></div>
                        <timeago class="is-size-8" :datetime="item2.dateCreated" :autoUpdate="0"></timeago><!-- <span class="is-size-8">{{az.dateConvert(item.dateCreated)}}</span> -->
                   </td>
                   <td style="padding-left: 5px; padding-bottom: 8px; ; padding-top: 4px"><span class="histFilterControl">{{item2.handle}}</span><br>
                  <span class="is-size-65" v-html="build(item2)"></span></td>
                  
               </tr>
           </table>
     </div>
      <!--   <div class="has-background-dark has-text-white" v-for="(item, i) in hists" :key="i">
            <div><span class="is-size-6"><b>{{az.dateConvert(item.dateCreated)}}</b></span>&nbsp;<span v-html="build(item)"></span></div>
        </div> -->
    </div>
</template>


<script>

export default{

    props: {
        obj:{
            type: Object,
            default: null
        }
    },

    data: function(){
        return {
            origHists: [],
            hists: [],
            bKey: [],
            az: az,
            fmiimus: true,
            fbundles: true,
            fcomments: true,
            fratings: true,
            inPublic: false,
            pComments: []
        }
    },

    mounted: function(){
      
        var self = this;

        function w(d){
            
            self.hists = d.h;
            self.bKey = d.key


            self.hists.forEach(e => {
                //e.details = JSON.parse(e.details)
                if(e.what == 'rating'){
                    e.details = parseInt(e.details)
                }
            })

            self.origHists = self.hists

            if(d.h.length)
                self.obj.caller.data.lastActivityId = d.h[0].id


        }

        function n(){

        }

        this.$root.app.apiClient.get(`subs/data/gethistory/${this.obj.collabId}/${this.obj.id}`, {}, w, n)
    },

    methods: {
        subsId: function(id){
            for(var i=0; i < this.bKey.length; i++){
                if(this.bKey[i].id == id){
                    return this.bKey[i].n
                }
            }

            return false
        },

        flipPublic: function(){
            
            if(this.inPublic){
                this.inPublic = false
            } else {
                this.inPublic = true
                this.getPublicComments()
                
            }
        },

        getPublicComments: function(){
           
            var self = this;

            function w(d){
                az.addRemSpinner(false, 'id', 'loader');
                self.pComments = d.r
                self.pComments.forEach(e => {
                    e.action = 'commented'
                    e.what = 'comment'
                    e.details = e.comment
                    e.objId = e.id_CARDS
                    e.fromId = e.id_BUNDLES
                }) 
            }

            function n(){
                az.addRemSpinner(false, 'id', 'loader');
            }

            az.addRemSpinner(true, 'id', 'loader');
            this.$root.app.apiClient.get('subs/data/collabcomments/' + this.obj.collabId, {}, w, n)

        },

        toggleFilter(f){
            var self = this
            var arr = []
            if(f == 'm'){
                this.fmiimus = !this.fmiimus
            } else if(f == 'b'){
                this.fbundles = !this.fbundles
            } else if(f == 'c'){
                this.fcomments = !this.fcomments
            } else if(f == 'r'){
                this.fratings = !this.fratings
            }

            if(this.fmiimus)
                arr.push('card')
            
            if(this.fbundles)
                arr.push('bundle')

            if(this.fcomments)
                arr.push('comment')

            if(this.fratings)
                arr.push('rating')

            this.hists = this.origHists.filter(e => {
                return arr.includes(e.what)
            })
        },

        build: function (i){
            if(i.what == 'bundle'){
                if(i.action == 'move'){
                    if(i.toId && !i.fromId){
                        return `<span class="has-text-coolGreen">added</span> <span class="subBundleLabel subBundleLabelInHistory" onclick="javascript: window.app.app.$refs.rightBarComp.openBundle(${i.objId})"><span class="has-text-coolGreen">::</span>${this.subsId(i.objId)}</span><br>
                                <div class="left27">to <span class="subBundleLabel subBundleLabelInHistory" onclick="javascript: window.app.app.$refs.rightBarComp.openBundle(${i.toId})"><span class="has-text-coolGreen">::</span>${this.subsId(i.toId)}</span></div>`
                    }

                    if(!i.toId && i.fromId){
                        return `<span class="has-text-coolGreen">removed</span> <span class="subBundleLabel subBundleLabelInHistory" onclick="javascript: window.app.app.$refs.rightBarComp.openBundle(${i.objId})"><span class="has-text-coolGreen">::</span>${this.subsId(i.objId)}</span><br> 
                                <div class="left27">from <span class="subBundleLabel subBundleLabelInHistory" onclick="javascript: window.app.app.$refs.rightBarComp.openBundle(${i.fromId})"><span class="has-text-coolGreen">::</span>${this.subsId(i.fromId)}</span></div>`
                    }

                    if(i.toId && i.fromId){
                        if(i.toId == i.fromId){
                            return `<span class="has-text-coolGreen">repositioned</span> <span class="subBundleLabel subBundleLabelInHistory" onclick="javascript: window.app.app.$refs.rightBarComp.openBundle(${i.objId})"><span class="has-text-coolGreen">::</span>${this.subsId(i.objId)}</span><br> 
                            <div class="left27">within <span class="subBundleLabel subBundleLabelInHistory" onclick="javascript: window.app.app.$refs.rightBarComp.openBundle(${i.fromId})"><span class="has-text-coolGreen">::</span>${this.subsId(i.fromId)}</span></div>`
                        } else {
                            return `<span class="has-text-coolGreen">moved</span> <span class="subBundleLabel subBundleLabelInHistory" onclick="javascript: window.app.app.$refs.rightBarComp.openBundle(${i.objId})"><span class="has-text-coolGreen">::</span>${this.subsId(i.objId)}</span><br> 
                            <div class="left27">
                                from <span class="subBundleLabel subBundleLabelInHistory" onclick="javascript: window.app.app.$refs.rightBarComp.openBundle(${i.fromId})"><span class="has-text-coolGreen">::</span>${this.subsId(i.fromId)}</span> 
                                to <span class="subBundleLabel subBundleLabelInHistory" onclick="javascript: window.app.app.$refs.rightBarComp.openBundle(${i.toId})"><span class="has-text-coolGreen">::</span>${this.subsId(i.toId)}</span>
                            </div>`
                        }
                    }
                }

                if(i.action == 'delete'){
                    if(!i.fromId && !i.toId){
                        return `<span class="has-text-coolGreen">deleted</span> collab bundle <span class="subBundleLabel subBundleLabelInHistory" onclick="javascript: window.app.app.$refs.rightBarComp.openBundle(${i.objId})"><span class="has-text-coolGreen">::</span>${this.subsId(i.objId)}`
                    }
                    return `<span class="has-text-coolGreen">removed</span> <span class="subBundleLabel subBundleLabelInHistory" onclick="javascript: window.app.app.$refs.rightBarComp.openBundle(${i.objId})"><span class="has-text-coolGreen">::</span>${this.subsId(i.objId)}</span><br> 
                    <div class="left27">from <span class="subBundleLabel subBundleLabelInHistory" onclick="javascript: window.app.app.$refs.rightBarComp.openBundle(${i.fromId})"><span class="has-text-coolGreen">::</span>${this.subsId(i.fromId)}</span></div>`
                }

                if(i.action == 'new' || i.action == 'add'){
                    if(!i.fromId && !i.toId){
                        return `<span class="has-text-coolGreen">created</span> collab <span class="subBundleLabel subBundleLabelInHistory" onclick="javascript: window.app.app.$refs.rightBarComp.openBundle(${i.objId})"><span class="has-text-coolGreen">::</span>${this.subsId(i.objId)}</span>`
                    }
                    return `<span class="has-text-coolGreen">added</span> <span class="subBundleLabel subBundleLabelInHistory" onclick="javascript: window.app.app.$refs.rightBarComp.openBundle(${i.objId})"><span class="has-text-coolGreen">::</span>${this.subsId(i.objId)}</span><br> 
                                <div class="left27">to <span class="subBundleLabel subBundleLabelInHistory" onclick="javascript: window.app.app.$refs.rightBarComp.openBundle(${i.toId})"><span class="has-text-coolGreen">::</span>${this.subsId(i.toId)}</span></div>`
                }

                if(i.action == 'edit'){
                    return `<span class="has-text-coolGreen">edited</span> <span class="subBundleLabel subBundleLabelInHistory" onclick="javascript: window.app.app.$refs.rightBarComp.openBundle(${i.objId})"><span class="has-text-coolGreen">::</span>${this.parseBundleDetails(i.details, false)}</span>.<br> 
                    <div class="left27">Name changed to <span class="subBundleLabel subBundleLabelInHistory" onclick="javascript: window.app.app.$refs.rightBarComp.openBundle(${i.objId})"><span class="has-text-coolGreen">::</span>${this.parseBundleDetails(i.details, true)}</span></div>`
                }
            }

            if(i.what == 'card'){
                if(i.action == 'move'){
                    if(i.fromId == i.toId){
                        return `<span class="has-text-coolGreen">repositioned</span> <span class="has-text-coolGreen"></span><span class="historyMiimu"
                            onclick="javascript: window.app.app.$refs.rightBarComp.openCard(${i.objId}, ${i.fromId}, ${i.collabId})">${this.getTitle(i.title)}</span><span class="has-text-coolGreen"></span><br> 
                            <div class="left27">within <span class="subBundleLabel subBundleLabelInHistory" onclick="javascript: window.app.app.$refs.rightBarComp.openBundle(${i.fromId})"><span class="has-text-coolGreen">::</span>${this.subsId(i.fromId)}</span></div>`
                    } else {
                        return `<span class="has-text-coolGreen">moved</span> <span class="has-text-coolGreen"></span><span class="historyMiimu"
                            onclick="javascript: window.app.app.$refs.rightBarComp.openCard(${i.objId}, ${i.toId}, ${i.collabId})">${this.getTitle(i.title)}</span><span class="has-text-coolGreen"></span><br> 
                        <div class="left27">
                            from <span class="subBundleLabelsubBundleLabelInHistory" onclick="javascript: window.app.app.$refs.rightBarComp.openBundle(${i.formId})"><span class="has-text-coolGreen">::</span>${this.subsId(i.fromId)}</span>  
                            to <span class="subBundleLabel subBundleLabelInHistory" onclick="javascript: window.app.app.$refs.rightBarComp.openBundle(${i.toId})"><span class="has-text-coolGreen">::</span>${this.subsId(i.toId)}</span>
                        </div>`
                    }
                    
                }

                if(i.action == 'add' || i.action == 'new'){
                    return `<span class="has-text-coolGreen">added</span> <span class="has-text-coolGreen"></span><span class="historyMiimu" 
                        onclick="javascript: window.app.app.$refs.rightBarComp.openCard(${i.objId}, ${i.toId}, ${i.collabId})">${this.getTitle(i.title)}</span><span class="has-text-coolGreen"></span><br> 
                        <div class="left27">to <span class="subBundleLabel subBundleLabelInHistory" onclick="javascript: window.app.app.$refs.rightBarComp.openBundle(${i.toId})"><span class="has-text-coolGreen">::</span>${this.subsId(i.toId)}</span></div>`
                }

                if(i.action == 'remove' || i.action == 'delete'){
                    return `<span class="has-text-coolGreen">removed</span> <span class="has-text-coolGreen"></span><span class="historyMiimu"
                        onclick="javascript: window.app.app.$refs.rightBarComp.openCard('removed')">${this.getTitle(i.title)}</span><span class="has-text-coolGreen"></span><br> 
                        <div class="left27">from <span class="subBundleLabel subBundleLabelInHistory" onclick="javascript: window.app.app.$refs.rightBarComp.openBundle(${i.fromId})"><span class="has-text-coolGreen">::</span>${this.subsId(i.fromId)}</span></div>`
                }

                if(i.action == 'edit'){
                    return `<span class="has-text-coolGreen">edited</span> <span class="has-text-coolGreen"></span><span class="historyMiimu"
                        onclick="javascript: window.app.app.$refs.rightBarComp.openCard(${i.objId}, ${undefined}, ${i.collabId})">${this.getTitle(i.title)}</span><span class="has-text-coolGreen"></span>.<br> 
                        <div class="left27"><span class="is-size-65"><b>Changes:</b></span><div class="is-size-65">${this.parseDetails(i.details)}</span></div></div>`
                }
            }

            if(i.what == 'comment'){
                if(i.action == 'commented'){
                    return `<span class="has-text-coolGreen">commented</span> <span class="has-text-coolGreen"></span> on <span class="historyMiimu" 
                        onclick="javascript: window.app.app.$refs.rightBarComp.openCard(${i.objId}, ${i.fromId}, ${i.collabId}, 'comments')">${this.getTitle(i.title)}</span><br>
                        <div class="left27"><div class="is-size-65 top5">${i.details}</div></div>`
                }

            }

            if(i.what == 'rating'){
                if(i.action == 'rated'){
                    return `<span class="has-text-coolGreen">rated</span> <span class="has-text-coolGreen"></span> <span class="historyMiimu" 
                        onclick="javascript: window.app.app.$refs.rightBarComp.openCard(${i.objId}, ${i.fromId}, ${i.collabId})">${this.getTitle(i.title)} </span> a <div class="is-inline-block ratingBox ${'rating' + i.details}">${i.details}</div>`
                }

            }

        },

        initials: function(val){
            for(var i=0; i < this.$root.app.groupMembers.length; i++){
                if(this.$root.app.groupMembers[i].id_customer == val){
                    return this.$root.app.groupMembers[i].fName.charAt(0).toUpperCase() + this.$root.app.groupMembers[i].lName.charAt(0).toUpperCase()
                }
            }
            return ""
        },

        getTitle: function(t){

            return  t.substring(0,20) + '...'

            /* let c = this.$root.app.cards.find(e => {
                return e.id == id
            })

            if(c){
                return c.title.substring(0,20) + '...'
            } else {
                return '[miimu since removed]'
            } */
        },

        parseDetails: function(v){
            if(!v){
                return ''
            }
             if(typeof(v) == 'object'){
                v = JSON.stringify(v)
            }
           
            v = JSON.parse(v)

            let r = ''
            if(v.title){
                r += '<b>Title: </b>' + v.title.split('#-').join("'") + '<br>'
            }
            if(v.note){
                r += '<b>Note: </b>' + v.note.split('#_').join("'") + '<br>'
            }
            if(v.description){
                r += '<b>Description: </b>' + v.description.split('#_').join("'") + '<br>'
            }
            if(v.img){
                r += '<b>Image: </b>' + 'changed image' + '<br>'
            }
            if(v.name){
                r += '<b>Name: </b>' + v.name.split('#_').join("'") + '<br>'
            }
            if(v.oldName){
                r += '<b>Old Name: </b>' + v.oldName.split('#_').join("'") + '<br>'
            }

            return r
        },

        parseBundleDetails: function(v, retName){
             if(!v){
                return ''
            }

            
            if(typeof(v) == 'object'){
                v = JSON.stringify(v)
            }
            v = JSON.parse(v) 

            if(retName){
                return v.name;
            } else {
                return v.oldName
            }
        },

        openBundle: function(id){

            /* let b = this.$root.app.bundles.find(e => {
                return e.id == id
            }) */
            var self = this;
            var b
            function rec(id, arr){
      
                arr.forEach(e => {
                    if(e.aliasTgtId == id){
                        b = e
                        return
                    } else if(e.id == id){
                        b = e
                        return
                    }

                    if(e.children.length){
                        rec(id, e.children)
                    }
                })
                   
            }
         
            rec(id, [this.$root.app.treeNoInbox[this.obj.listIndex]])

            if(b){
                this.$root.app.$refs.routerView.$refs.rootBundleContainers[this.obj.listIndex].data = b;
            } else {
                this.$root.app.showModalOK({message: 'The bundle you clicked on no longer exists.'})
            }
        },

        openCard: async function(id, bundleId, collabId, goTo){

            if(id == 'removed'){
                this.$root.app.showModalOK({message: 'This miimu has been removed by its contributor.'})
                return
            }
            
            var ind = this.$root.app.cards.findIndex(e => {
                return e.id == id
            })

            if(ind == -1){
               
                //make call to get 
                await this.$root.app.loadOneCard(id + '-' + collabId)

                ind = this.$root.app.cards.findIndex(e => {
                return e.id == id
            })

            }

            //is Edited, must find a bundle that contains it
            if(bundleId == undefined){
                var arr = this.$root.app.bundles.filter(e => {
                    return e.collabId == collabId
                })
                
                for(var i=0; i<arr.length; i++){
                    for(var x=0; x < arr[i].items.length; x++){
                        if(arr[i].items[x].id == id){
                            bundleId = arr[i].id;
                            break
                        }
                    }
                }
               
            }

            if(goTo){
                if(goTo == 'comments'){
                    this.$root.app.doShowModal('editModal', {url: '', cardsIndex: ind, callApi: false, caller: this, bundleId: bundleId, collabIdFromUrlCard: this.obj.collabId, goToComments: true, parentPublic: this.obj.caller.$data.data.isPublic ? true : false, selectPublic: this.inPublic})
                }
            } else {
                this.$root.app.doShowModal('editModal', {url: '', cardsIndex: ind, callApi: false, caller: this, bundleId: bundleId, collabIdFromUrlCard: this.obj.collabId})
            }
        }
    
    },
    computed: {
        filtered: function(){
            return this.hists
        }
    }
}

</script>

<style scoped>
    #xButt{
        background-color: transparent !important;
        position: fixed;
        font-size: 2rem !important;
        right: 10px;
        z-index: 3
    }

  
    .delete::after{
        width: 1px;
        height: 100%
    }
     .delete::before{
        height: 1px;
        width: 100%
    }
</style>